import { __decorate, __extends } from "tslib";
import { reviewBodySlicer } from './';
import s from '../solution-rate-reviews.scss';
import React from 'react';
import { nameToAvatarFormatter } from './solution-review-title';
import { withMarketplaceStore } from '../../../../../component-decorators/with-marketplace-store';
import { Avatar, Box, Text, TextButton } from 'wix-style-react';
import { composer } from '../../../../../component-decorators/composer';
var ReviewReply = /** @class */ (function (_super) {
    __extends(ReviewReply, _super);
    function ReviewReply(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isLongReview: _this.isBodyTooLong(_this.props.reply.description),
            expandedBody: false,
        };
        _this.getReviewBodyText = _this.getReviewBodyText.bind(_this);
        _this.expandToggle = _this.expandToggle.bind(_this);
        return _this;
    }
    ReviewReply.prototype.isBodyTooLong = function (body) {
        return body && body.split(' ').length > 34;
    };
    ReviewReply.prototype.getReviewBodyText = function () {
        return this.state.isLongReview && !this.state.expandedBody
            ? reviewBodySlicer(this.props.reply.description)
            : this.props.reply.description;
    };
    ReviewReply.prototype.expandToggle = function () {
        this.setState(function (prevState) {
            return {
                expandedBody: !prevState.expandedBody,
            };
        });
    };
    ReviewReply.prototype.render = function () {
        return (React.createElement(Box, { className: s.replayContainer },
            React.createElement(Avatar, { name: nameToAvatarFormatter(this.props.developerName), imgProps: { src: this.props.developerIcon }, size: this.props.isMobile ? 'size30' : 'size48' }),
            React.createElement(Box, { marginLeft: this.props.isMobile ? "6px" : "18px", direction: "vertical" },
                React.createElement(Text, { className: s.reviewReplyTitle, size: "small", weight: "normal" },
                    React.createElement(TranslatedKey, { tkey: 'solution.page.review.reply.team', data: {
                            developer: this.props.developerName,
                        } })),
                React.createElement(Text, { dataHook: "review-" + (this.props.reply.id && this.props.reply.id), className: s.reviewBody, size: this.props.isMobile ? "small" : "medium", weight: "thin" }, this.getReviewBodyText()),
                this.state.isLongReview && (React.createElement(TextButton, { dataHook: "reply-body-expander-" + this.props.reply.id, onClick: this.expandToggle }, this.state.expandedBody ? (React.createElement(TranslatedKey, { tkey: 'solution.page.review.readLess' })) : (React.createElement(TranslatedKey, { tkey: 'solution.page.review.readMore' })))))));
    };
    ReviewReply = __decorate([
        withMarketplaceStore
    ], ReviewReply);
    return ReviewReply;
}(React.Component));
export { ReviewReply };
var TranslatedKey = composer()
    .withTranslation()
    .compose(function (_a) {
    var t = _a.t, tkey = _a.tkey, data = _a.data;
    return t(tkey, data);
});
//# sourceMappingURL=solution-review-reply.js.map